// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-aria-ModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: var(--visual-viewport-height);
  background: rgba(0 0 0 / 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;

  &[data-entering] {
    animation: modal-fade 200ms;
  }

  &[data-exiting] {
    animation: modal-fade 150ms reverse ease-in;
  }
}

.react-aria-Modal {
  box-shadow: 0 8px 20px rgba(0 0 0 / 0.1);
  border-radius: 6px;
  background: var(--overlay-background);
  color: var(--text-color);
  border: 1px solid var(--gray-400);
  outline: none;

  &[data-entering] {
    animation: modal-zoom 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  .react-aria-TextField {
    margin-bottom: 8px;
  }
}

@keyframes modal-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes modal-zoom {
  from {
    transform: scale(0.8);
  }

  to {
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Reusable/Modal/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;;EAEZ;IACE,2BAA2B;EAC7B;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,iCAAiC;EACjC,aAAa;;EAEb;IACE,mEAAmE;EACrE;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".react-aria-ModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: var(--visual-viewport-height);\n  background: rgba(0 0 0 / 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n\n  &[data-entering] {\n    animation: modal-fade 200ms;\n  }\n\n  &[data-exiting] {\n    animation: modal-fade 150ms reverse ease-in;\n  }\n}\n\n.react-aria-Modal {\n  box-shadow: 0 8px 20px rgba(0 0 0 / 0.1);\n  border-radius: 6px;\n  background: var(--overlay-background);\n  color: var(--text-color);\n  border: 1px solid var(--gray-400);\n  outline: none;\n\n  &[data-entering] {\n    animation: modal-zoom 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  }\n\n  .react-aria-TextField {\n    margin-bottom: 8px;\n  }\n}\n\n@keyframes modal-fade {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modal-zoom {\n  from {\n    transform: scale(0.8);\n  }\n\n  to {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
